<template>
  <div class="page-container" ref="parentScroll">
    <div class="page-content">
      <ActivityNavBar
        v-if="isApp"
        :opacity="navBarOpacity"
        @share="bindShare"
      ></ActivityNavBar>
      <div v-if="isInit && activityInfo && activityInfo.activity_crowd">
        <van-pull-refresh
          style="min-height: 100vh"
          :pull-distance="100"
          v-model="isRefresh"
          :disabled="!isApp"
          @refresh="onRefresh"
        >
          <div
            class="activity-container"
            :class="{ 'activity-container-wx': !isApp }"
          >
            <div class="top">
              <div class="rules-btn" @click="showRulesToast = true"
                >活动规则</div
              >
              <Group1 v-if="activityInfo.activity_crowd == 1"></Group1>
              <Group2 v-else-if="activityInfo.activity_crowd == 2"></Group2>
              <Group3 v-else-if="activityInfo.activity_crowd == 4"></Group3>
              <Group4 v-else-if="activityInfo.activity_crowd == 3"></Group4>
              <GroupNotApp
                v-else-if="activityInfo.activity_crowd == 5"
              ></GroupNotApp>
            </div>
            <div
              class="bottom"
              v-if="!isRefresh"
              :style="{ height: bottomContentHeight + 'px' }"
            >
              <img
                class="hot"
                src="https://btw-common-data.betterwestar.com/btw-admin/resource/4d262e1a62ddacf8aa71bae343cf3a70_wh=93_42.png"
                alt=""
              />
              <div class="weixin-jum-app" v-if="!isApp">
                <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
              </div>
              <van-tabs
                v-model="active"
                @change="bindTabChange"
                :line-width="tabData[active].title.length * 16 + 'px'"
              >
                <van-tab
                  :disabled="!isApp && index != 1"
                  :title="item.title"
                  v-for="(item, index) in tabData"
                  :key="index"
                >
                  <div
                    class="page-view"
                    :style="{ height: bottomContentHeight - 41 + 'px' }"
                  >
                    <div
                      class="page-scroll"
                      ref="childScroll"
                      :class="{ 'page-scorll-disabled': !item.scroll }"
                    >
                      <CoachRank
                        v-if="index == 0"
                        :scroll="item.scroll"
                        @dynamic="bindToDynamic"
                      ></CoachRank>
                      <UgcComponent v-if="index == 1" :scroll="item.scroll" />
                      <StoreList v-if="index == 2" :scroll="item.scroll" />
                    </div>
                  </div>
                </van-tab>
              </van-tabs>
              <!-- <div class="page-view">
                <div
                  v-for="(item, index) in tabData"
                  :key="item.id"
                  class="page-scroll"
                  ref="childScroll"
                  v-show="active == index"
                  :class="{ 'page-scorll-disabled': !item.scroll }"
                >
                  <CoachRank v-if="index == 0"></CoachRank>
                  <UgcComponent v-if="index == 1" />
                  <StoreList v-if="index == 2" />
                </div>
              </div> -->
            </div>
          </div>
        </van-pull-refresh>
        <!-- 送花功能 -->
        <van-popup
          v-model="showSendFlowerToast"
          position="bottom"
          @close="bindCloseSendFlower"
        >
          <SendFlower
            get-container="body"
            :show="showSendFlowerToast"
            @close="showSendFlowerToast = false"
          />
        </van-popup>
        <!-- 送花动效 -->
        <van-popup
          :lazy-render="false"
          overlay-class="lottery-overlay"
          :close-on-click-overlay="false"
          v-model="showLotteryAnimateToast"
        >
          <LotteryAnimate
            :show="showLotteryAnimateToast"
            @close="bindCompleteAnimate"
          ></LotteryAnimate>
        </van-popup>
        <!-- 我的奖品 -->
        <van-popup
          v-model="showMyPrizeToast"
          position="bottom"
          @close="bindCloseMyPrize"
        >
          <MyPrize
            :show="showMyPrizeToast"
            @close="showMyPrizeToast = false"
            :data="prizeData"
          />
        </van-popup>
        <!-- 获取小红花任务 -->
        <van-popup
          v-model="showTaskToast"
          position="bottom"
          @close="bindCloseTask"
        >
          <TaskList :show="showTaskToast" @close="showTaskToast = false" />
        </van-popup>
        <!-- 送花记录 -->
        <van-popup
          v-model="showRecordToast"
          position="bottom"
          @close="bindCloseRecord"
        >
          <RecordList
            :show="showRecordToast"
            @close="showRecordToast = false"
          />
        </van-popup>
        <!-- 活动规则 -->
        <van-popup v-model="showRulesToast" position="bottom">
          <RulesPage @close="showRulesToast = false" />
        </van-popup>
        <!-- 抽奖界面 -->
        <van-popup
          v-model="showLotteryToast"
          position="bottom"
          :overlay="activityInfo.activity_crowd == 2"
          @close="bindCloseLottery"
        >
          <LotteryPage @close="bindCloseLottery" />
        </van-popup>
      </div>
      <AppLoading class="app-loading" v-if="isLoading" />
      <!-- 分享组件 -->
      <ShareComponent
        v-model="showShare"
        :options="iconList"
        @cancel="bindCancel"
        @select="bindSelect"
        :qrcodeUrl="qrcodeUrl"
      />
    </div>
  </div>
</template>
<script>
import { eventObj } from '@/components/app/share/share-method.js'
import ActivityNavBar from './components/nav-bar.vue'
import AppLoading from '@/components/app/loading/loading.vue'
import ShareComponent from '@/components/app/share/share.vue'
import CoachRank from './components/pageview-coach-rank.vue'
import UgcComponent from './components/ugc.vue'
import StoreList from './components/store.vue'
import Group1 from './components/group-1.vue'
import Group2 from './components/group-2.vue'
import Group3 from './components/group-3.vue'
import Group4 from './components/group-4.vue'
import GroupNotApp from './components/group-not-app.vue'
import SendFlower from './components/sen-flower.vue'
import MyPrize from './components/my-prize.vue'
import TaskList from './components/task-list.vue'
import RecordList from './components/record-list.vue'
import RulesPage from './components/rules.vue'
import LotteryPage from './components/lottery-result.vue'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import LotteryAnimate from './components/lottery-animate.vue'
export default {
  name: 'jianmeng-coach-vote-2024',
  components: {
    ActivityNavBar,
    WxOpenLaunchApp,
    AppLoading,
    LotteryAnimate,
    SendFlower,
    CoachRank,
    UgcComponent,
    StoreList,
    Group1,
    Group2,
    Group3,
    Group4,
    GroupNotApp,
    MyPrize,
    TaskList,
    RecordList,
    RulesPage,
    ShareComponent,
    LotteryPage
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'rgba(0,0,0,0)'
      },
      isApp: false,
      showSendFlowerToast: false,
      showMyPrizeToast: false,
      showTaskToast: false,
      showRecordToast: false,
      showRulesToast: false,
      showLotteryToast: false,
      showLotteryAnimateToast: false,
      showShare: false,
      qrcodeUrl: '',
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        }
      ],
      shareOptions: {
        //分享参数
        url: '',
        desc: '因WE有你，喜事发生',
        title: '2024健萌最用心教练评选',
        thumbnail:
          'https://btw-common-data.betterwestar.com/btw-admin/resource/efe484ce317a99e8b921586c4f1bdda1_wh=100_100.png'
      },
      extinfo: '',
      isInit: false, //是否初始化
      isRefresh: false,
      isLoading: true,
      parentScroll: null,
      childScroll: null,
      isParentAtTop: true, // 标记父滚动区域是否在顶部
      isParentAtBottom: false, // 标记父滚动区域是否在底部
      isChildAtTop: true, // 标记子滚动区域是否在顶部
      isChildAtBottom: false, // 标记子滚动区域是否在底部
      active: 0,
      bottomContentHeight: 0,
      statusBarHeight: 0,
      navBarOpacity: 0,
      tabData: [
        {
          id: 1,
          title: '教练榜',
          scroll: false
        },
        {
          id: 2,
          title: '精选瞬间',
          scroll: false
        },
        {
          id: 3,
          title: '门店榜',
          scroll: false
        }
      ],
      prizeData: null
    }
  },
  computed: {
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    },
    computeSendFlowerToast() {
      return this.$store.state.coachActivity2024.sendFlowerPage.showToast
    },
    computeMyPrizeToast() {
      return this.$store.state.coachActivity2024.myPrizePage.showToast
    },
    computeTaskToast() {
      return this.$store.state.coachActivity2024.taskPage.showToast
    },
    computeRecordToast() {
      return this.$store.state.coachActivity2024.recordPage.showToast
    },
    computeLotteryToast() {
      return this.$store.state.coachActivity2024.lotteryPage.showToast
    },
    computeLotteryAnimateToast() {
      return this.$store.state.coachActivity2024.lotteryAnimate.showToast
    }
  },
  watch: {
    computeSendFlowerToast() {
      if (this.computeSendFlowerToast) {
        this.showSendFlowerToast = true
      }
    },
    computeMyPrizeToast() {
      if (this.computeMyPrizeToast) {
        this.showMyPrizeToast = true
      }
    },
    computeTaskToast() {
      if (this.computeTaskToast) {
        this.showTaskToast = true
      }
    },
    computeRecordToast() {
      if (this.computeRecordToast) {
        this.showRecordToast = true
      }
    },
    computeLotteryToast() {
      if (this.computeLotteryToast) {
        this.showLotteryToast = true
      }
    },
    computeLotteryAnimateToast() {
      if (this.computeLotteryAnimateToast) {
        this.showLotteryAnimateToast = true
      }
    },
    active() {
      this.bindTabChange()
    }
  },
  created() {
    this.getBottomContentHeight()
    this.init()
  },
  mounted() {
    this.$refs.parentScroll.addEventListener('scroll', this.bindScroll, {
      passive: false
    })
  },
  destroyed() {
    window.onPageResumed = null
  },
  methods: {
    bindToDynamic() {
      this.active = 1
    },
    async getBottomContentHeight() {
      let lessHeight = 18 //需要减去20px,避免显示圆角
      if (this.$betterwe.isApp()) {
        let res = await this.$betterwe.getAppBarHeight().catch(() => {})
        if (res) {
          this.tabBarHeight = res.toolsBarHeight
          this.statusBarHeight = res.statusBarHeight
          this.bottomContentHeight =
            window.innerHeight -
            (this.tabBarHeight + this.statusBarHeight - lessHeight)
        }
      } else {
        lessHeight = 8 //需要减去20px,避免显示圆角
        this.tabBarHeight = 0
        this.statusBarHeight = 0
        this.bottomContentHeight =
          window.innerHeight -
          (this.tabBarHeight + this.statusBarHeight - lessHeight)
      }
    },
    async init() {
      this.isApp = this.$betterwe.isApp()
      this.qrcodeUrl = location.origin + location.pathname
      let url = location.origin + location.pathname
      this.extinfo = '/web?url=' + encodeURIComponent(url)
      window.onPageResumed = async () => {
        let isGuest = await this.$betterwe.isGuest()
        if (isGuest) {
          this.$toast('请登录')
        } else {
          this.getActivityInfo(true)
        }
      }
      //未登录
      if (this.$betterwe.isApp()) {
        let isGuest = await this.$betterwe.isGuest()
        if (!isGuest) {
          this.getActivityInfo()
        } else {
          this.$betterwe.isLogin()
        }
      } else {
        this.getActivityInfo()
      }
    },
    async getActivityInfo(isRefresh = false) {
      await this.$store.dispatch('coachActivity2024/initActivity')
      await Promise.all([
        this.$store.dispatch('coachActivity2024/actionActivityIndex'),
        this.$store.dispatch('coachActivity2024/actionPrizeList')
      ])
      this.isLoading = false
      this.isInit = true
      if (!isRefresh && [2, 5].includes(this.activityInfo.activity_crowd)) {
        this.active = 1
      }
      if (isRefresh) {
        this.isRefresh = false
      }
      if (!this.addDLog) {
        this.$http.addDataLog({
          eventk: 'BG_huodong_COACH_xiaohonghua',
          eventv: `BG_huodong_COACH_xiaohonghua_${this.activityInfo.activity_crowd}`
        })
        this.addDLog = true
      }
    },
    bindCloseSendFlower() {
      this.$store.commit('coachActivity2024/setShowSendFlowerToast', false)
    },
    bindCloseMyPrize() {
      this.$store.commit('coachActivity2024/setMyPrizeToast', false)
    },
    bindCloseTask() {
      this.$store.commit('coachActivity2024/setTaskToast', false)
    },
    bindCloseRecord() {
      this.$store.commit('coachActivity2024/setRecordToast', false)
    },
    bindCloseLottery() {
      this.showLotteryToast = false
      this.showLotteryAnimateToast = false
      this.$store.commit('coachActivity2024/setShowSendFlowerToast', false)
      this.$store.commit('coachActivity2024/setLotteryAnimateToast', false)
      this.$store.commit('coachActivity2024/setLotteryToast', false)
    },
    onRefresh() {
      this.isLoading = true
      this.getActivityInfo(true)
    },
    bindScroll(e) {
      let el = e.target
      let minHeight = 50
      let maxHeight = 100
      var scroll = Math.round(e.target.scrollTop)
      let isBottom = scroll >= el.scrollHeight - el.offsetHeight - 1
      this.$set(this.tabData[this.active], 'scroll', isBottom)
      if (scroll < minHeight) {
        this.navBarOpacity = 0
      }
      if (scroll > maxHeight) {
        this.navBarOpacity = 1
      } else {
        let pecent = (scroll - minHeight) / (maxHeight - minHeight)
        this.navBarOpacity = parseFloat(pecent.toFixed(2))
      }
    },
    bindBack() {
      this.$http.appBack()
    },
    bindCancel() {
      this.iconList = []
    },
    bindClick() {
      this.$router.push('/nutrition-clock/index?id=2&c=3')
    },
    bindShare() {
      this.showShare = true
    },
    bindCancel() {
      this.showShare = false
    },
    bindTabChange(value) {
      let el = this.$refs.parentScroll
      let isBottom = el.scrollTop >= el.scrollHeight - el.offsetHeight
      this.tabData[this.active].scroll = isBottom
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    bindCompleteAnimate() {
      this.showLotteryToast = true
    }
  }
}
</script>
<style lang="scss" scoped>
.app-loading {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}
.page-container {
  height: 100vh;
  overflow-y: scroll;
  overscroll-behavior: none;
  ::v-deep .van-overlay {
    background-color: rgba(0, 0, 0, 0.6);
  }
  ::v-deep .lottery-overlay {
    background-color: rgba(0, 0, 0, 0.8);
  }
  ::v-deep .van-popup {
    background-color: transparent;
    overflow-y: visible;
  }
  ::v-deep .van-tabs__wrap {
    padding-top: 16px;
    padding-bottom: 16px;
    //padding-top: 1s0px;
    position: relative;
    height: 25px;
  }
  ::v-deep .van-tabs__nav {
    position: relative;
    z-index: 3;
    background-color: transparent;
    padding: 0px 5px 15px;
    .van-info {
      top: -4px;
      right: -1px;
      padding: 0px 4px 0px 3px;
      height: 14px;
      background: #ff2270;
      border-radius: 8px 8px 8px 0px;
      font-family: GothamBlack;
      font-weight: normal;
      font-style: italic;
      font-size: 10px;
      color: #ffffff;
      line-height: 14px;
    }
  }
  ::v-deep .van-tab {
    flex: 0 0 auto;
    padding: 0px 15px;
    font-size: 16px;
    font-weight: bold;
    color: rgba(5, 11, 39, 0.5);
    line-height: 22px;
  }
  ::v-deep .van-tab--active {
    font-weight: bold;
    font-size: 16px;
    color: #050b27;
    line-height: 22px;
  }
  ::v-deep .van-tabs__line {
    width: 80px;
    height: 9px;
    z-index: -1;
    background-color: #ffeabd;
    border-radius: 0px;
  }
  ::v-deep .van-pull-refresh__head {
    color: #050b27;
  }
}
.activity-container {
  background-image: url('https://btw-common-data.betterwestar.com/btw-admin/resource/6584fbc53c281bf14d463300c164bd03_wh=1125_1329.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center 60px;
}
.activity-container-wx {
  background-position: center 20px;
}
.page-content {
  min-height: 100vh;
  background-color: #ffc6df;
}
.top {
  position: relative;
  .rules-btn {
    width: 28px;
    box-sizing: border-box;
    text-align: center;
    padding: 5px 5px;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 4px 0px 0px 4px;
    right: 0;
    top: 200px;
    z-index: 1;
    font-size: 12px;
    line-height: 14px;
    color: #fff;
  }
}
.bottom {
  position: relative;
  background: #ffffff;
  border-radius: 16px 16px 0px 0px;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  .hot {
    z-index: 3;
    position: absolute;
    object-fit: contain;
    left: 148px;
    top: 6px;
    width: 31px;
    height: 14px;
  }
  .weixin-jum-app {
    position: absolute;
    width: 100%;
    height: 41px;
    left: 0;
    top: 0;
  }
  .page-view {
    position: relative;
    height: calc(100vh - 121px);
    .page-scroll {
      height: 100%;
      overflow-y: scroll;
      .item {
        height: 50px;
        border-bottom: 1px solid #ececec;
      }
      .page-item-0 {
      }
      .page-item-1 {
      }
      .page-item-2 {
      }
    }
    .page-scorll-disabled {
      overflow-y: hidden;
    }
  }
}
.share-container {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>
